import { render, staticRenderFns } from "./SupervisedPersonList.vue?vue&type=template&id=53692806&scoped=true"
import script from "./SupervisedPersonList.vue?vue&type=script&lang=js"
export * from "./SupervisedPersonList.vue?vue&type=script&lang=js"
import style0 from "./SupervisedPersonList.vue?vue&type=style&index=0&id=53692806&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53692806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53692806')) {
      api.createRecord('53692806', component.options)
    } else {
      api.reload('53692806', component.options)
    }
    module.hot.accept("./SupervisedPersonList.vue?vue&type=template&id=53692806&scoped=true", function () {
      api.rerender('53692806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/SupervisedPersonManager/SupervisedPersonList.vue"
export default component.exports